export enum Step {
  PROCESS = 'PROCESS',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  LOADING = 'LOADING',
}

export const QR_CODE_VALID_TIMER_KEY = 'qrCodeLimitTimer';
export const QR_CODE_FLAG = 'QR_CODE';
